// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fw","homeTitle_styleDefault":"c-a_fx","homeTitle_styleRed":"c-a_fy"};